<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 order-xs1>
        <controlBar/>
      </v-flex>
      <v-flex xs12 md7 order-xs3 order-md2 style="margin: 10px">
        <groupCard/>
      </v-flex>
      <v-flex xs12 md4 order-xs2 style="margin: 10px">
        <joinCard/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import controlBar from '../components/bar/controlBar/controlBar.vue'
import groupCard from '../components/card/groupCard/groupCard.vue'
import joinCard from '../components/card/joinCard/joinCard.vue'
export default {
  name: 'home',
  components: {
    controlBar,
    groupCard,
    joinCard
  }
}
</script>
